import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Dashboard',
		component: () =>
			import(/* webpackChunkName: "course" */ './components/Dashboard.vue'),
		meta: {
			breadcrumb: 'Dashboard',
		},
	},
	{
		name: 'Create',
		path: '/create',
		component: () =>
			import(/* webpackChunkName: "create" */ './components/admin/Create.vue'),
		props: true,
		meta: {
			breadcrumb: 'Create',
		},
	},
	{
		name: 'Statistics',
		path: '/statistics',
		component: () =>
			import(
				/* webpackChunkName: "statistics" */ './components/admin/Statistics.vue'
			),
		props: true,
		meta: {
			breadcrumb: 'Statistics',
		},
	},
	{
		name: 'Course',
		path: '/course/:id',
		component: () =>
			import(
				/* webpackChunkName: "course" */ './components/dashboard/Course.vue'
			),
		props: true,
		meta: {
			breadcrumb() {
				return {
					label: 'Course',
					parent: 'Dashboard',
				}
			},
		},
	},
	{
		name: 'Quiz',
		path: '/quiz/:id',
		component: () =>
			import(/* webpackChunkName: "quiz" */ './components/dashboard/Quiz.vue'),
		props: true,
		meta: {
			breadcrumb() {
				return {
					label: 'Quiz',
					parent: 'Dashboard',
				}
			},
		},
	},
	{
		path: '/about',
		name: 'About',
		component: () =>
			import(/* webpackChunkName: "about" */ './components/About.vue'),
		meta: {
			breadcrumb: 'About',
		},
	},
	{
		path: '/help',
		name: 'Help Center',
		component: () =>
			import(/* webpackChunkName: "about" */ './components/HelpCenter.vue'),
		meta: {
			breadcrumb: 'Help Center',
		},
	},
	{
		path: '/profile',
		name: 'Profile',

		component: () =>
			import(/* webpackChunkName: "about" */ './components/Profile.vue'),
		meta: {
			breadcrumb: 'Profile',
		},
	},
	{
		path: '/authenticate',
		name: 'Login',
		component: () =>
			import(/* webpackChunkName: "about" */ './components/Login.vue'),
		meta: {
			breadcrumb: 'Login',
		},
	},
	{
		path: '/reset',
		name: 'Reset Password',
		component: () =>
			import(/* webpackChunkName: "about" */ './components/ResetPassword.vue'),
		meta: {
			breadcrumb: 'Reset Password',
		},
	},
]

// 404
routes.push({
	path: '*',
	name: 'Not found',
	component: () =>
		import(/* webpackChunkName: "about" */ './components/NotFound.vue'),
	meta: {
		breadcrumb: 'Not found',
	},
})

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

export default router
